
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/november-2019-update",
      function () {
        return require("private-next-pages/blog/november-2019-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/november-2019-update"])
      });
    }
  